import store from '../../stores/reduxStore'
import gql from 'graphql-tag'
import {logout, userRefreshToken} from '../../actions/user'

function getUserFromStore() {
  let redux_store = JSON.parse(JSON.stringify(store.getState()))
  if (redux_store.user.data !== null) {
    return redux_store.user.data
  } else {
    return {}
  }
}

export function getAccessToken() {
  const user = getUserFromStore()
  return user.auth_token
}

export function getRefreshToken() {
  const user = getUserFromStore()
  return user.refresh_token
}

export const REFRESH_USER_TOKEN = gql`
  mutation refreshUserToken($refresh_token: String!) {
    refreshUserToken(refresh_token: $refresh_token) {
      token
      refresh_token
    }
  }
`

export async function refreshTokenMutation(apolloClient) {
  return await apolloClient.mutate({
    mutation: REFRESH_USER_TOKEN,
    variables: {refresh_token: getRefreshToken()}
  }).then(({data}) => {
    if (data.refreshUserToken && data.refreshUserToken.token) {
      const {token, refresh_token} = data.refreshUserToken
      store.dispatch(userRefreshToken({auth_token: token, refresh_token: refresh_token}))
    } else {
      store.dispatch(logout())
    }

    return data.refreshUserToken
  })
}



// WEBPACK FOOTER //
// ./src/utils/api/jwt.js